import { RiskScoreLevelEnum } from '@/api';

const normalizedLevelToText: Record<string, string> = {
  medium: 'middle',
};

export default function getLevelByRiskType(riskType: string): string {
  let level = RiskScoreLevelEnum.UNKNOWN;

  switch (riskType) {
    case 'trusted':
      level = RiskScoreLevelEnum.LOW;
      break;
    case 'suspicious':
      level = RiskScoreLevelEnum.MEDIUM;
      break;
    case 'danger':
      level = RiskScoreLevelEnum.HIGH;
      break;
    default:
      break;
  }

  return normalizedLevelToText[level] || level;
}
